module.exports = __webpack_public_path__ + "static/media/user-tag.f811f981.svg";